/* eslint-disable-next-line import/prefer-default-export */
export const LoginErrors = {
  INVALID_CREDENTIALS: 'invalid_credentials',
  OTHER: 'other',
};

export const PROFITROVER_WEBAPP = process.env.REACT_APP_PROFITROVER_WEBAPP;
export const PROFITROVER_WEBSITE = process.env.REACT_APP_PROFITROVER_WEBSITE;
